module.exports = __webpack_public_path__ + "img/add_passenger_icon.615ed428.png";